import { render, staticRenderFns } from "./DescritoresEditor.vue?vue&type=template&id=55bd8646&scoped=true"
import script from "./DescritoresEditor.vue?vue&type=script&lang=js"
export * from "./DescritoresEditor.vue?vue&type=script&lang=js"
import style0 from "./DescritoresEditor.vue?vue&type=style&index=0&id=55bd8646&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55bd8646",
  null
  
)

export default component.exports